<template>
  <div class="container">
    <QueryFrame
      :disablePage='disablePage'
      :count= 'count'
      :current="page"
      :showEmptyLine="true"
    >
      <div slot="table">
        <div class="phone">
          <div style="line-height: 35px;">患者手机号：</div>
          <lk-form :rules='rules' :model='phoneModel' ref="phone">
            <lk-row>
              <lk-form-item prop="phone">
              <lk-input style="width: 220px;" v-model.trim='phoneModel.phone' placeholder="请输入"> </lk-input>
            </lk-form-item>
            </lk-row>
          </lk-form>
          <div class="btns">
            <lk-button  @click="handleUpload" type='primary'>发送</lk-button>
          </div>
        </div>
        <div class="sms">短信内容：【邻客智慧药房】感谢您在邻客药房购药，您可以在邻客智慧药房小程序中预约输注服务，详情请点击https://app.linkdoc.com/egg/s/szyy</div>
      </div>
    </QueryFrame>
  </div>
  </template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import toolsService from '../../services/tools';

export default {
  name: 'infusion',
  mixins: [mapState, queryMixins],
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!this.phoneModel.phone) {
        callback(new Error('请输入手机号码'));
      } else {
        const phone = [/^1[3465789]\d{9}$/, /^0\d{2,3}\s?\d{7,8}$/];
        let ifsuccess = false;
        phone.forEach((item, index) => {
          if (item.test(this.phoneModel.phone)) {
            ifsuccess = true;
          }
        });
        ifsuccess ? callback() : callback(new Error('请输入手机号码'));
      }
    };
    return {
      disablePage: true,
      phoneModel: { phone: '' },
      rules: {
        phone: [
          { required: true, validator: validatePhone, trigger: 'change' },
        ],
      },
    };
  },
  methods: {
    handleUpload() {
      this.$refs.phone.validate((msg) => {
        if (msg) {
          toolsService.notify({ phone: this.phoneModel.phone }).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('发送成功');
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      });
    },
  },
  components: {
    QueryFrame,
  },
};
</script>
<style>
  .btns{
    margin-bottom: 12px;
    margin-left: 16px;
  }
  .sms {
    margin-left: 29px;
    margin-bottom: 20px;
    margin-top: 10px;
  }
  .phone {
    display:flex;
    margin-top: 20px;
    margin-left: 16px;
  }
</style>
